import { Col, Input, Row } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import Highlighter from "react-highlight-words";
import { useMemo, useState } from "react";

export function normalizarBusca(valor) {
  if (valor == null) {
    return "";
  }
  return String(valor).trim().toLowerCase();
}

function obterValorCampo(registro, campo) {
  return String(campo)
    .split(".")
    .reduce((atual, chave) => (atual == null ? atual : atual[chave]), registro);
}

function textoParaBusca(valor) {
  if (typeof valor === "boolean") {
    return valor ? "sim true impede necessita" : "nao não false nao impede nao necessita";
  }
  if (valor == null) {
    return "";
  }
  return String(valor);
}

export function registroContemBusca(registro, busca, campos) {
  const termo = normalizarBusca(busca);
  if (!termo) {
    return true;
  }
  return campos.some((campo) =>
    normalizarBusca(textoParaBusca(obterValorCampo(registro, campo))).includes(
      termo
    )
  );
}

export function filtrarPorBusca(lista, busca, campos) {
  if (!Array.isArray(lista)) {
    return [];
  }
  return lista.filter((item) => registroContemBusca(item, busca, campos));
}

export function destacarBusca(texto, busca) {
  const termo = (busca || "").trim();
  if (!termo || texto == null) {
    return texto;
  }
  return (
    <Highlighter
      highlightStyle={{ backgroundColor: "var(--main-color)", padding: 0 }}
      searchWords={[termo]}
      autoEscape
      textToHighlight={String(texto)}
    />
  );
}

export function useBuscaInstantanea(lista, campos, tamanhoInicial = 10) {
  const [busca, setBusca] = useState("");
  const [pagina, setPagina] = useState(1);
  const [tamanhoPagina, setTamanhoPagina] = useState(tamanhoInicial);
  const camposChave = Array.isArray(campos) ? campos.join("|") : "";

  const filtrados = useMemo(
    () =>
      filtrarPorBusca(
        lista,
        busca,
        camposChave ? camposChave.split("|") : []
      ),
    [lista, busca, camposChave]
  );

  function onChangeBusca(valor) {
    setBusca(valor);
    setPagina(1);
  }

  return {
    busca,
    onChangeBusca,
    filtrados,
    paginacaoBusca: {
      size: "small",
      current: pagina,
      pageSize: tamanhoPagina,
      showSizeChanger: true,
      onChange: (page, pageSize) => {
        setPagina(page);
        setTamanhoPagina(pageSize);
      },
    },
  };
}

export function CampoBuscaInstantanea({
  value,
  onChange,
  placeholder = "Busque",
}) {
  return (
    <Row gutter={[16, 16]} style={{ marginBottom: 16 }}>
      <Col xs={24} md={12} lg={8}>
        <Input
          allowClear
          prefix={<SearchOutlined />}
          placeholder={placeholder}
          value={value}
          onChange={(event) => onChange(event.target.value)}
        />
      </Col>
    </Row>
  );
}
